import React, { PropsWithChildren } from 'react';
import { IModalDefault } from './types';
import * as SC from './styles';
import Icon from '../Icon';
import Lottie from 'lottie-react';
import useModalWelcomeAi from './hooks/useModalWelcomeAi';
import animationData from '../../assets/animations/u60ekp0bPy.json';

const ModalWelcomeAI: React.FC<PropsWithChildren<IModalDefault>> = ({
  isOpen,
  onClose,
}) => {
  const { handleNavigateGreenfyAi } = useModalWelcomeAi({ onClose });
  return (
    <SC.Overlay isOpen={isOpen}>
      <SC.Background>
        <SC.ModalContent onClick={(e) => e.stopPropagation()}>
          <SC.ButtonClose onClick={onClose}>
            <Icon iconName="CloseOutlined" htmlColor="#226A43" />
          </SC.ButtonClose>

          <SC.ContentGift>
            <Lottie animationData={animationData} loop autoplay />
          </SC.ContentGift>

          <SC.ContentText>
            <SC.WrapperTexts>
              <SC.Quest>Você pediu?</SC.Quest>
              <SC.Quest>Agora CHEGOU!</SC.Quest>
            </SC.WrapperTexts>

            <SC.WrapperTitle>
              <Icon
                iconName="AutoAwesomeOutlined"
                fontSize="large"
                htmlColor="#226A43"
              />
              <SC.Title>Greenfy A.I</SC.Title>
            </SC.WrapperTitle>

            <SC.WrapperTexts>
              <SC.Describe>Agora você tem uma A.I</SC.Describe>
              <SC.Describe>integrada com a sua FAZENDA!</SC.Describe>
            </SC.WrapperTexts>

            <SC.Button onClick={handleNavigateGreenfyAi}>
              QUERO CONHECER A GREENFY A.I
            </SC.Button>
          </SC.ContentText>
        </SC.ModalContent>
      </SC.Background>
    </SC.Overlay>
  );
};

export default ModalWelcomeAI;
